// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"499":"b1f4a6fc","999":"168451e6"}[chunkId] + ".chunk.js";
};